import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const API_BASE = '/planner-api';

export const fetchOverview = createAsyncThunk('stats/fetchOverview', async (token) => {
  const res = await fetch(`${API_BASE}/stats/overview`, { headers: { Authorization: `Bearer ${token}` } });
  if (!res.ok) throw new Error('Failed to fetch overview');
  return res.json();
});

export const fetchMonthlyCosts = createAsyncThunk('stats/fetchMonthlyCosts', async ({ token, months = 6 }) => {
  const res = await fetch(`${API_BASE}/stats/costs?months=${months}`, { headers: { Authorization: `Bearer ${token}` } });
  if (!res.ok) throw new Error('Failed to fetch monthly costs');
  return res.json();
});

export const fetchCostsByDriver = createAsyncThunk('stats/fetchCostsByDriver', async (token) => {
  const res = await fetch(`${API_BASE}/stats/costs-by-driver`, { headers: { Authorization: `Bearer ${token}` } });
  if (!res.ok) throw new Error('Failed to fetch costs by driver');
  return res.json();
});

export const fetchCostsByVehicle = createAsyncThunk('stats/fetchCostsByVehicle', async (token) => {
  const res = await fetch(`${API_BASE}/stats/costs-by-vehicle`, { headers: { Authorization: `Bearer ${token}` } });
  if (!res.ok) throw new Error('Failed to fetch costs by vehicle');
  return res.json();
});

export const fetchAlerts = createAsyncThunk('stats/fetchAlerts', async (token) => {
  const res = await fetch(`${API_BASE}/stats/alerts`, { headers: { Authorization: `Bearer ${token}` } });
  if (!res.ok) throw new Error('Failed to fetch alerts');
  return res.json();
});

const statsSlice = createSlice({
  name: 'stats',
  initialState: {
    overview: null,
    monthlyCosts: [],
    costsByDriver: [],
    costsByVehicle: [],
    alerts: [],
    loading: { overview: false, costs: false, drivers: false, vehicles: false, alerts: false },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOverview.pending, (s) => { s.loading.overview = true; })
      .addCase(fetchOverview.fulfilled, (s, a) => { s.overview = a.payload; s.loading.overview = false; })
      .addCase(fetchOverview.rejected, (s) => { s.loading.overview = false; })
      .addCase(fetchMonthlyCosts.pending, (s) => { s.loading.costs = true; })
      .addCase(fetchMonthlyCosts.fulfilled, (s, a) => { s.monthlyCosts = a.payload; s.loading.costs = false; })
      .addCase(fetchMonthlyCosts.rejected, (s) => { s.loading.costs = false; })
      .addCase(fetchCostsByDriver.pending, (s) => { s.loading.drivers = true; })
      .addCase(fetchCostsByDriver.fulfilled, (s, a) => { s.costsByDriver = a.payload; s.loading.drivers = false; })
      .addCase(fetchCostsByDriver.rejected, (s) => { s.loading.drivers = false; })
      .addCase(fetchCostsByVehicle.pending, (s) => { s.loading.vehicles = true; })
      .addCase(fetchCostsByVehicle.fulfilled, (s, a) => { s.costsByVehicle = a.payload; s.loading.vehicles = false; })
      .addCase(fetchCostsByVehicle.rejected, (s) => { s.loading.vehicles = false; })
      .addCase(fetchAlerts.pending, (s) => { s.loading.alerts = true; })
      .addCase(fetchAlerts.fulfilled, (s, a) => { s.alerts = a.payload; s.loading.alerts = false; })
      .addCase(fetchAlerts.rejected, (s) => { s.loading.alerts = false; });
  },
});

export const selectOverview = (s) => s.stats.overview;
export const selectMonthlyCosts = (s) => s.stats.monthlyCosts;
export const selectCostsByDriver = (s) => s.stats.costsByDriver;
export const selectCostsByVehicle = (s) => s.stats.costsByVehicle;
export const selectAlerts = (s) => s.stats.alerts;
export const selectStatsLoading = (s) => s.stats.loading;
export default statsSlice.reducer;
